<template>
  <div class="BackButton" :class="{ 'share': on_share }" @click="onClick()"> 
    <div ref="icon" class="BackButton__icon"> 
      <svg viewBox="0 0 19.2 25.78">
        <rect class="cls-1" x="3.01" y="14.67" width="18.02" height="2.23" transform="translate(9.42 35.45) rotate(-135.19)"/>
        <path class="cls-1" d="M6.56-3H8.79a0,0,0,0,1,0,0v17.3a2.23,2.23,0,0,1-2.23,2.23h0a0,0,0,0,1,0,0V-3A0,0,0,0,1,6.56-3Z" transform="translate(8.35 17.02) rotate(-135.24)"/>
        <rect class="cls-1" x="13.93" y="2.24" width="2.23" height="9.36" transform="translate(20.85 22.43) rotate(-135.24)"/>
        <path class="cls-1" d="M5.41,15.13l10.05,10h0a2.24,2.24,0,0,1-3.16,0L3.83,16.72Z"/>
      </svg>
    </div>
    <div ref="txt" class="BackButton__txt">{{ trans('GLOBAL.back') }}</div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'BackButton',
  data: ()=>({
    on_share: false,
  }),
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.on_share = this.$root.route.to.params.step == 'share' ? true : false
      }
    }
  },
  mounted() { 

    const delay = this.$root.route.to.params.section == 'support' ? .75 : 1.75

    gsap.from([  this.$refs.icon, this.$refs.txt ], {
        duration: .35, 
          x: '+=200%', 
          ease: 'cubic.out', 
          opacity: 0,
          stagger: .1,
          delay: delay, 
    })
  },

  methods:{
    onClick() {
      if(this.$root.route.to.params.section == 'support')
        this.$parent.hideWeb()
      else if(this.$root.route.to.params.section == 'story')
        this.$router.push({ params: { section: undefined } })
      else if(this.$root.route.to.params.section == 'record')
        this.$router.push({ params: { section: 'voice' } })
      else 
        this.$router.push({ params: { section: 'story' } })
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.BackButton
  position absolute
  top 0px
  left 0px
  display flex
  align-items center
  padding 32px
  color white
  transition opacity .35s
  opacity 1

  &.share
    opacity .25
    pointer-events none

  &__icon 
    width 2.8vh
    height 2.8vh

  &__txt 
    padding-left 12px

  .cls-1
    fill #fff

</style>


